import React from 'react';
import clsx from 'clsx';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import { useTranslation } from 'react-i18next';

import StoryButton from '../../../../components/story-button/StoryButton';
import StoryBadge from '../../../../components/story-badge/StoryBadge';
import StoryMediaView from '../../../../components/story-media-view/StoryMediaView';
import useStoryMediaDisplay from '../../../../hooks/useStoryMediaDisplay';
import { getStoryMediaId, isStoryMediaUploading, isUploadedStoryMedia } from '../../../../media/storyMediaItem';

import scss from './FilmstripItem.module.scss';

function FilmstripItem({ media, isActive, onSelect, onRemove }) {
  const { t } = useTranslation('story');
  const mediaId = getStoryMediaId(media);
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: mediaId,
  });

  const { isVideo } = useStoryMediaDisplay(media);
  const isCustom = isUploadedStoryMedia(media) && !isStoryMediaUploading(media);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleSelect = () => {
    onSelect(mediaId);
  };

  const handleRemove = (event) => {
    event.stopPropagation();
    onRemove(mediaId);
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={clsx(scss.item, isActive && scss.active, isDragging && scss.dragging)}
      {...attributes}
      {...listeners}>
      <button type='button' className={scss.thumbButton} onClick={handleSelect}>
        <StoryMediaView media={media} variant='card' className={scss.thumb} />

        {isVideo ? (
          <span className={scss.playIcon} aria-hidden='true'>
            <PlayArrowOutlinedIcon />
          </span>
        ) : null}

        {isCustom ? <StoryBadge label={t('custom')} size='sm' className={scss.customBadge} /> : null}
      </button>

      <StoryButton
        icon={CloseIcon}
        onClick={handleRemove}
        ariaLabel={t('removeMedia')}
        size='sm'
        className={scss.removeButton}
      />
    </div>
  );
}

export default FilmstripItem;
